import { API_BASE } from '../config';
import { GuardApiItem, GuardDailyResponse } from './types';

export const GUARD_MIN_DATE = parseGuardDate('20260329');

export function formatGuardDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}${month}${day}`;
}

export function parseGuardDate(value: string): Date {
  if (!/^\d{8}$/.test(value)) {
    return new Date();
  }

  return new Date(
    Number(value.slice(0, 4)),
    Number(value.slice(4, 6)) - 1,
    Number(value.slice(6, 8))
  );
}

export function extractGuardApiErrorMessage(error: any): string {
  const detail =
    error?.response?.data?.detail ??
    error?.detail ??
    error?.message;

  if (typeof detail === 'string' && detail.trim()) {
    return detail;
  }

  return '守卫数据加载失败';
}

export function clampGuardDate(date: Date, minDate: Date, maxDate: Date): Date {
  const value = date.getTime();
  if (value < minDate.getTime()) {
    return new Date(minDate);
  }
  if (value > maxDate.getTime()) {
    return new Date(maxDate);
  }
  return new Date(date);
}

function normalizeItem(item: GuardApiItem, index: number, date: string) {
  const safeTitle = (item.title || '').trim() || '未命名消息';
  const safePlatform = (item.platform || '').trim();
  return {
    id: `${date}-${index}-${safePlatform || 'unknown'}-${safeTitle}`,
    title: safeTitle,
    platform: safePlatform,
    fetch_time: (item.fetch_time || '').trim(),
    core_content: (item.core_content || '').trim(),
    summary_points: Array.isArray(item.summary_points)
      ? item.summary_points.map((point) => String(point || '').trim()).filter(Boolean)
      : [],
    keywords: Array.isArray(item.keywords) ? item.keywords.filter(Boolean) : [],
    raw_transcript: (item.raw_transcript || '').trim(),
  };
}

export async function fetchGuardDaily(date: string, signal?: AbortSignal): Promise<GuardDailyResponse> {
  const token = localStorage.getItem('access_token');
  const response = await fetch(`${API_BASE}/api/guard/daily?date=${date}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    signal,
  });

  const contentType = response.headers.get('content-type') || '';
  const payload = contentType.includes('application/json') ? await response.json() : null;

  if (!response.ok) {
    const error = new Error(payload?.detail || response.statusText || '守卫数据加载失败');
    (error as any).response = { data: payload };
    throw error;
  }

  const items = Array.isArray(payload?.items) ? payload.items : [];

  return {
    date: payload?.date || date,
    total: Number(payload?.total || items.length || 0),
    items: items.map((item: GuardApiItem, index: number) => normalizeItem(item, index, payload?.date || date)),
  };
}
